import { render } from "./ChangeUserPermissionsComponent.vue?vue&type=template&id=a967c21e"
import script from "./ChangeUserPermissionsComponent.vue?vue&type=script&lang=js"
export * from "./ChangeUserPermissionsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__